module.exports = __webpack_public_path__ + "img/butter-dog.71914cbb.svg";